var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTab4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 14.875H30.8125L19.125 3.1875V14.875ZM4.25 0H21.25L34 12.75V38.25C34 39.3772 33.5522 40.4582 32.7552 41.2552C31.9582 42.0522 30.8772 42.5 29.75 42.5H4.25C3.12283 42.5 2.04183 42.0522 1.2448 41.2552C0.447766 40.4582 0 39.3772 0 38.25V4.25C0 1.89125 1.89125 0 4.25 0ZM6.375 38.25H10.625V25.5H6.375V38.25ZM14.875 38.25H19.125V21.25H14.875V38.25ZM23.375 38.25H27.625V29.75H23.375V38.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 14.875H30.8125L19.125 3.1875V14.875ZM4.25 0H21.25L34 12.75V38.25C34 39.3772 33.5522 40.4582 32.7552 41.2552C31.9582 42.0522 30.8772 42.5 29.75 42.5H4.25C3.12283 42.5 2.04183 42.0522 1.2448 41.2552C0.447766 40.4582 0 39.3772 0 38.25V4.25C0 1.89125 1.89125 0 4.25 0ZM6.375 38.25H10.625V25.5H6.375V38.25ZM14.875 38.25H19.125V21.25H14.875V38.25ZM23.375 38.25H27.625V29.75H23.375V38.25Z",
    fill: "url(#paint0_linear_444_5339)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_5339",
    x1: 31.7944,
    y1: -2.59034,
    x2: -11.4013,
    y2: 23.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3AACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab4);
export default __webpack_public_path__ + "static/media/tab-4.f29e390641839cb0cc7cbaff72373e90.svg";
export { ForwardRef as ReactComponent };